// Mock data for Portal demonstration with 5-role system
export const mockUsers = [
  { id: 1, name: 'John Smith', email: 'john.smith@example.com', role: 'teacher', campus: 'Claremont', status: 'active', createdAt: '2024-01-15' },
  { id: 2, name: 'Mary Johnson', email: 'mary.j@example.com', role: 'parent', campus: null, status: 'active', createdAt: '2024-02-20' },
  { id: 3, name: 'Robert Brown', email: 'robert.b@example.com', role: 'teacher', campus: 'Nedlands', status: 'active', createdAt: '2024-03-10' },
  { id: 4, name: 'Lisa Chen', email: 'lisa.chen@example.com', role: 'parent', campus: null, status: 'active', createdAt: '2024-03-15' },
  { id: 5, name: 'David Wilson', email: 'david.w@example.com', role: 'super_admin', campus: null, status: 'active', createdAt: '2023-12-01' },
  { id: 6, name: 'Sarah Mitchell', email: 'sarah.m@example.com', role: 'system_admin', campus: null, status: 'active', createdAt: '2023-11-01' },
  { id: 7, name: 'Michael Zhang', email: 'michael.z@example.com', role: 'campus_admin', campus: 'Claremont', status: 'active', createdAt: '2024-01-05' },
  { id: 8, name: 'Emily Davis', email: 'emily.d@example.com', role: 'campus_admin', campus: 'Nedlands', status: 'active', createdAt: '2024-01-08' },
  { id: 9, name: 'Alex Thompson', email: 'alex.t@example.com', role: 'teacher', campus: 'City', status: 'active', createdAt: '2024-02-01' },
];

export const mockStudents = [
  {
    id: 1,
    name: 'Emma Johnson',
    grade: 'Year 5',
    school: 'ABC Primary School',
    campus: 'Claremont',
    parentId: 2,
    parentName: 'Mary Johnson',
    enrolledCourses: [1, 2],
    status: 'active',
    paidWeeks: 8,
    totalWeeks: 12,
    credits: 4
  },
  {
    id: 2,
    name: 'James Chen',
    grade: 'Year 6',
    school: 'XYZ High School',
    campus: 'Claremont',
    parentId: 4,
    parentName: 'Lisa Chen',
    enrolledCourses: [1],
    status: 'active',
    paidWeeks: 12,
    totalWeeks: 12,
    credits: 0
  },
  {
    id: 3,
    name: 'Sophie Williams',
    grade: 'Year 4',
    school: 'ABC Primary School',
    campus: 'Claremont',
    parentId: 2,
    parentName: 'Mary Johnson',
    enrolledCourses: [3],
    status: 'active',
    paidWeeks: 6,
    totalWeeks: 12,
    credits: 6
  },
  {
    id: 4,
    name: 'Oliver Davis',
    grade: 'Year 7',
    school: 'Central High',
    campus: 'City',
    parentId: 4,
    parentName: 'Lisa Chen',
    enrolledCourses: [5],
    status: 'not_active',
    paidWeeks: 0,
    totalWeeks: 12,
    credits: 0
  },
  {
    id: 5,
    name: 'Sophia Lee',
    grade: 'Year 5',
    school: 'Nedlands Primary',
    campus: 'Nedlands',
    parentId: 4,
    parentName: 'Lisa Chen',
    enrolledCourses: [4],
    status: 'active',
    paidWeeks: 10,
    totalWeeks: 12,
    credits: 2
  },
  {
    id: 6,
    name: 'Lucas Anderson',
    grade: 'Year 6',
    school: 'Nedlands Primary',
    campus: 'Nedlands',
    parentId: 2,
    parentName: 'Mary Johnson',
    enrolledCourses: [6],
    status: 'active',
    paidWeeks: 12,
    totalWeeks: 12,
    credits: 0
  },
];

export const mockCourseGroups = [
  // Claremont Campus
  {
    id: 1,
    name: 'Year 5 Comprehensive - Term 1',
    grade: 'Year 5',
    term: 'Term 1 2025',
    campus: 'Claremont',
    type: 'regular',
    teacherId: 1,
    teacherName: 'John Smith',
    students: [1, 2],
    totalStudents: 2,
    activeThisWeek: 2,
    // Multiple subjects with separate schedules
    subjects: [
      {
        name: 'English',
        schedule: 'Monday 4:00 PM - 5:30 PM'
      },
      {
        name: 'Mathematics',
        schedule: 'Wednesday 5:00 PM - 6:30 PM'
      }
    ]
  },
  {
    id: 2,
    name: 'Year 6 Advanced Program',
    grade: 'Year 6',
    term: 'Term 1 2025',
    campus: 'Claremont',
    type: 'regular',
    teacherId: 1,
    teacherName: 'John Smith',
    students: [2, 1],
    totalStudents: 2,
    activeThisWeek: 2,
    subjects: [
      {
        name: 'Mathematics',
        schedule: 'Tuesday 4:00 PM - 5:30 PM'
      },
      {
        name: 'Science',
        schedule: 'Thursday 4:00 PM - 5:30 PM'
      }
    ]
  },
  {
    id: 3,
    name: 'Year 4 English - Intensive',
    grade: 'Year 4',
    term: 'Term 1 2025',
    campus: 'Claremont',
    type: 'non-regular',
    teacherId: 1,
    teacherName: 'John Smith',
    students: [3],
    totalStudents: 1,
    activeThisWeek: 0,
    subjects: [
      {
        name: 'English',
        schedule: 'Friday 3:00 PM - 4:30 PM'
      }
    ]
  },
  // Nedlands Campus
  {
    id: 4,
    name: 'Year 5 STEM Program',
    grade: 'Year 5',
    term: 'Term 1 2025',
    campus: 'Nedlands',
    type: 'regular',
    teacherId: 3,
    teacherName: 'Robert Brown',
    students: [5],
    totalStudents: 1,
    activeThisWeek: 1,
    subjects: [
      {
        name: 'Science',
        schedule: 'Tuesday 4:00 PM - 5:30 PM'
      },
      {
        name: 'Mathematics',
        schedule: 'Friday 4:00 PM - 5:30 PM'
      }
    ]
  },
  {
    id: 6,
    name: 'Year 6 English Excellence',
    grade: 'Year 6',
    term: 'Term 1 2025',
    campus: 'Nedlands',
    type: 'regular',
    teacherId: 3,
    teacherName: 'Robert Brown',
    students: [6],
    totalStudents: 1,
    activeThisWeek: 1,
    subjects: [
      {
        name: 'English',
        schedule: 'Thursday 5:00 PM - 6:30 PM'
      }
    ]
  },
  // City Campus
  {
    id: 5,
    name: 'Year 7 Advanced Program',
    grade: 'Year 7',
    term: 'Term 1 2025',
    campus: 'City',
    type: 'regular',
    teacherId: 9,
    teacherName: 'Alex Thompson',
    students: [4],
    totalStudents: 1,
    activeThisWeek: 0,
    subjects: [
      {
        name: 'Mathematics',
        schedule: 'Saturday 10:00 AM - 11:30 AM'
      },
      {
        name: 'Physics',
        schedule: 'Saturday 11:30 AM - 1:00 PM'
      }
    ]
  },
];

export const mockMaterials = [
  {
    id: 1,
    name: 'Year 5 English Week 1.pdf',
    subject: 'English',
    grade: 'Year 5',
    term: 'Term 1',
    week: 1,
    uploadedBy: 'Admin',
    uploadedAt: '2025-01-05T10:30:00',
    type: 'official',
    printCount: 15,
    viewCount: 45,
    hasAnswers: true,
  },
  {
    id: 2,
    name: 'Year 6 Math Week 1.pdf',
    subject: 'Mathematics',
    grade: 'Year 6',
    term: 'Term 1',
    week: 1,
    uploadedBy: 'Admin',
    uploadedAt: '2025-01-05T11:00:00',
    type: 'official',
    printCount: 20,
    viewCount: 60,
    hasAnswers: true,
  },
  {
    id: 3,
    name: 'Custom Grammar Exercises.pdf',
    subject: 'English',
    grade: 'Year 5',
    term: 'Term 1',
    week: 2,
    uploadedBy: 'John Smith',
    uploadedAt: '2025-01-15T14:20:35',
    type: 'teacher',
    printCount: 5,
    viewCount: 12,
    hasAnswers: false,
  },
];

export const mockBillings = [
  {
    id: 1,
    studentId: 1,
    studentName: 'Emma Johnson',
    courseGroup: 'Year 5 English - Term 1',
    amount: 480,
    weeks: 12,
    discount: 0,
    status: 'partially_paid',
    paidAmount: 320,
    paidWeeks: 8,
    createdAt: '2025-01-10',
    dueDate: '2025-02-01',
  },
  {
    id: 2,
    studentId: 2,
    studentName: 'James Chen',
    courseGroup: 'Year 6 Math - Term 1',
    amount: 500,
    weeks: 12,
    discount: 50,
    status: 'paid',
    paidAmount: 450,
    paidWeeks: 12,
    createdAt: '2025-01-08',
    dueDate: '2025-01-25',
  },
  {
    id: 3,
    studentId: 3,
    studentName: 'Sophie Williams',
    courseGroup: 'Year 4 English - Intensive',
    amount: 600,
    weeks: 12,
    discount: 100,
    status: 'partially_paid',
    paidAmount: 250,
    paidWeeks: 6,
    createdAt: '2025-01-12',
    dueDate: '2025-02-05',
  },
  {
    id: 4,
    studentId: 4,
    studentName: 'Oliver Davis',
    courseGroup: 'Year 7 Advanced Math',
    amount: 480,
    weeks: 12,
    discount: 0,
    status: 'unpaid',
    paidAmount: 0,
    paidWeeks: 0,
    createdAt: '2025-01-15',
    dueDate: '2025-02-10',
  },
];

export const mockFeedbacks = [
  {
    id: 1,
    courseGroupId: 1,
    courseGroupName: 'Year 5 English - Term 1',
    teacherId: 1,
    teacherName: 'John Smith',
    content: 'Week 1: Great start to the term! Students showed enthusiasm and engagement. We covered comprehension strategies and vocabulary building. Emma and James both demonstrated excellent reading skills. Homework: Complete reading comprehension worksheet.',
    createdAt: '2025-01-20T16:00:00',
    week: 1,
  },
  {
    id: 2,
    courseGroupId: 2,
    courseGroupName: 'Year 6 Math - Term 1',
    teacherId: 1,
    teacherName: 'John Smith',
    content: 'Week 1: Excellent participation from all students. We focused on algebraic expressions and problem-solving techniques. Most students grasped the concepts well. Homework: Practice problems 1-15 from workbook.',
    createdAt: '2025-01-22T17:30:00',
    week: 1,
  },
  {
    id: 3,
    courseGroupId: 4,
    courseGroupName: 'Year 5 Science - Term 1',
    teacherId: 3,
    teacherName: 'Robert Brown',
    content: 'Week 1: Introduction to scientific method. Sophia was very engaged and asked great questions about the experiments. Looking forward to more hands-on activities next week.',
    createdAt: '2025-01-21T16:30:00',
    week: 1,
  },
];

export const mockLeaveRequests = [
  {
    id: 1,
    studentId: 3,
    studentName: 'Sophie Williams',
    courseGroupId: 3,
    courseGroupName: 'Year 4 English - Intensive',
    date: '2025-01-24',
    reason: 'Family vacation',
    status: 'approved',
    requestedAt: '2025-01-18T09:00:00',
  },
  {
    id: 2,
    studentId: 1,
    studentName: 'Emma Johnson',
    courseGroupId: 1,
    courseGroupName: 'Year 5 English - Term 1',
    date: '2025-01-27',
    reason: 'Medical appointment',
    status: 'pending',
    requestedAt: '2025-01-23T14:30:00',
  },
];

export const mockTeacherInfo = {
  1: {
    id: 1,
    name: 'John Smith',
    email: 'john.smith@example.com',
    phone: '0412 345 678',
    birthday: '1990-05-15',
    hireDate: '2023-01-10',
    address: '123 Main St, Perth WA 6000',
    bankDetails: 'BSB: 123-456, Account: 987654321',
    education: 'Bachelor of Education, University of WA',
    wwcNumber: 'WWC1234567',
    workDays: 730,
    rewards: ['Outstanding Teacher 2024', 'Best Engagement Award'],
    campus: 'Claremont',
  },
  3: {
    id: 3,
    name: 'Robert Brown',
    email: 'robert.b@example.com',
    phone: '0423 456 789',
    birthday: '1988-08-22',
    hireDate: '2022-06-15',
    address: '456 Park Ave, Perth WA 6001',
    bankDetails: 'BSB: 234-567, Account: 123456789',
    education: 'Master of Mathematics Education, Curtin University',
    wwcNumber: 'WWC7654321',
    workDays: 1000,
    rewards: ['Math Excellence Award 2023'],
    campus: 'Nedlands',
  },
  9: {
    id: 9,
    name: 'Alex Thompson',
    email: 'alex.t@example.com',
    phone: '0434 567 890',
    birthday: '1992-03-10',
    hireDate: '2024-02-01',
    address: '789 City Road, Perth WA 6003',
    bankDetails: 'BSB: 345-678, Account: 111222333',
    education: 'Bachelor of Science, Master of Teaching',
    wwcNumber: 'WWC9876543',
    workDays: 365,
    rewards: ['New Teacher Excellence 2024'],
    campus: 'City',
  },
};

export const mockComplianceRecords = [
  {
    userId: 2,
    userName: 'Mary Johnson',
    privacyAgreed: true,
    photoSharingAgreed: true,
    agreedAt: '2024-02-20T10:00:00',
  },
  {
    userId: 4,
    userName: 'Lisa Chen',
    privacyAgreed: true,
    photoSharingAgreed: false,
    agreedAt: '2024-03-15T11:30:00',
  },
];

// Helper to get all unique campuses
export const mockCampuses = ['Claremont', 'Nedlands', 'City'];
